import apiClient from '@/services/rest-api-featurehub/apiClient'

const baseEndpoint = '/features'

export const getFeaturehubData = async () => {
  const apiKey = process.env.VUE_APP_APIKEY_FEATUREHUB
    const response = await apiClient({
      method: 'GET',
      url: `${baseEndpoint}?apiKey=${apiKey}`,
    })
    return response?.data
}
